<div class="flex items-start gap-3 p-4 rounded-md border" [ngClass]="containerClasses()" role="alert">
  @if (showIcon()) {
    <ts-icon class="flex-shrink-0 mt-0.5" [icon]="iconName()" size="small" />
  }
  <div class="flex flex-col gap-1 flex-1 min-w-0">
    @if (title()) {
      <p class="m-0 text-sm font-semibold">{{ title() }}</p>
    }
    <div class="text-sm">
      <ng-content></ng-content>
    </div>
  </div>
</div>
